import { Link } from "react-router-dom";
import { AppStoreBadge, GooglePlayBadge } from "./MkBadges";
import { PRODUCT_FEATURES, INDUSTRIES_NAV } from "./navData";

const RESOURCE_LINKS = [
  { label: "Blog", to: "/blog" },
  { label: "Documentation", to: "/docs" },
  { label: "Quick Start", to: "/quick-start" },
  { label: "Video Tutorials", to: "/tutorials" },
  { label: "Compare Software", to: "/compare" },
  { label: "Release Notes", to: "/release-notes" },
  { label: "Support Center", to: "/support" },
];

const COMPANY_LINKS = [
  { label: "Pricing", to: "/pricing" },
  { label: "Multi-Location", to: "/multi-location" },
  { label: "Book a Demo", to: "/book-demo" },
  { label: "Contact", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
];

const Column = ({ title, children }) => (
  <div>
    <h4 className="text-[12px] font-semibold uppercase tracking-[0.14em] text-slate-500 mb-4">{title}</h4>
    <ul className="space-y-2.5">{children}</ul>
  </div>
);

const FooterLink = ({ to, children }) => (
  <li>
    <Link to={to} className="text-[14px] text-slate-400 hover:text-white transition-colors">
      {children}
    </Link>
  </li>
);

const MarketingFooter = () => (
  <footer className="bg-[#020617] border-t border-slate-800/60 pt-16 pb-8" data-testid="marketing-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 md:grid-cols-6 gap-10 mb-14">
        <div className="col-span-2">
          <img src="/logo.png" alt="Fieldz AI" className="h-9 object-contain mb-4" />
          <p className="text-[14px] text-slate-400 max-w-sm leading-[1.7] mb-6">
            The all-in-one field service management platform. Schedule, dispatch, call, text, invoice, and get paid — from one place.
          </p>
          <div className="flex items-center gap-3 flex-wrap">
            <AppStoreBadge />
            <GooglePlayBadge />
          </div>
        </div>

        <div className="col-span-2 md:col-span-2">
          <h4 className="text-[12px] font-semibold uppercase tracking-[0.14em] text-slate-500 mb-4">Product</h4>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 mb-6">
            {PRODUCT_FEATURES.map((f) => (
              <li key={f.label}>
                <Link to={f.href} className="text-[14px] text-slate-400 hover:text-white transition-colors">
                  {f.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/features" className="text-[14px] text-slate-300 font-semibold hover:text-white transition-colors">
                All features →
              </Link>
            </li>
          </ul>
          <h4 className="text-[12px] font-semibold uppercase tracking-[0.14em] text-slate-500 mb-4">Industries</h4>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-2.5">
            {INDUSTRIES_NAV.map((f) => (
              <li key={f.label}>
                <Link to={f.href} className="text-[14px] text-slate-400 hover:text-white transition-colors">
                  {f.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <Column title="Resources">
          {RESOURCE_LINKS.map((l) => (
            <FooterLink key={l.label} to={l.to}>{l.label}</FooterLink>
          ))}
        </Column>

        <Column title="Company">
          {COMPANY_LINKS.map((l) => (
            <FooterLink key={l.label} to={l.to}>{l.label}</FooterLink>
          ))}
        </Column>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-slate-700/60 to-transparent mb-7" />

      <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-[12.5px] text-slate-500">© 2026 Fieldz AI. All rights reserved.</p>
        <p className="text-[12.5px] text-slate-500">4190 E Commerce Way, Sacramento, CA 95834</p>
      </div>
    </div>
  </footer>
);

export default MarketingFooter;
